import { displayRate, displayTerm } from '../../../../util';
import {
  getScorecardElementValue,
  isScorecardElementNotCalculable,
  isScorecardTermElement,
  ScorecardElementSymbol,
  useScorecard,
} from '../../../../Scorecard';
import { useScoreHealthRangeValueItemPositioning } from './useScoreHealthRangeValueItemPositioning';
import { ScoreHealthRangeBreakpoint } from '../types';

interface UseScoreHealthRangeScoreIndicatorProps {
  householdID: string;
  numberOfSections: number;
  element: ScorecardElementSymbol;
  scoreOverride?: number | null;
  breakpoints: ScoreHealthRangeBreakpoint[];
}

export function useScoreHealthRangeScoreIndicator({
  element,
  breakpoints,
  householdID,
  numberOfSections,
  scoreOverride,
}: UseScoreHealthRangeScoreIndicatorProps) {
  const { scorecard, scorecardQuery } = useScorecard({ householdID });
  const rangeValue = scoreOverride ?? getScorecardElementValue(scorecard, element) ?? 0;
  const { leftStyle } = useScoreHealthRangeValueItemPositioning({ rangeValue, breakpoints, numberOfSections });

  const isLoading = scoreOverride === undefined || scoreOverride === null ? scorecardQuery.isLoading : false;
  const isScoreNotCalculable = isScorecardElementNotCalculable(scorecard, element);
  const scoreDisplay = isScoreNotCalculable
    ? '––'
    : isScorecardTermElement(element)
    ? displayTerm(rangeValue)
    : displayRate(rangeValue, { withSymbol: true });

  return { leftStyle, isLoading, isScoreNotCalculable, scoreDisplay, element };
}
